<template>
  <div id="tickets">
    <div class="column column-100">
      <div class="box shadow">
        <topdata :data="topData"></topdata>
      </div>
    </div>

    <div class="column column-50">
      <div class="box shadow">
        <h2>
          Nog niet toegewezen tickets
          <span v-if="tickets_not_assigned.loaded">{{tickets_not_assigned.data.length}}</span>
        </h2>

        <transition name="fade">
          <div class="content"
               v-if="tickets_not_assigned.loaded && tickets_not_assigned.error === null">

            <ticket v-for="ticket in tickets_not_assigned.data"
                    :id="ticket._id"
                    :title="ticket.title | truncate(60)"
                    :client="ticket.client.name | truncate(60)"
                    :updated="ticket.updated_at | moment('D-M-YYYY')"
                    :key="ticket._id"></ticket>
          </div>
        </transition>

        <div class="loader" v-if="!tickets_not_assigned.loaded"></div>
      </div>
    </div><!--

    --><div class="column column-50">
    <div class="box shadow">
      <h2>
        Mijn tickets
        <span v-if="tickets_mine.loaded">{{tickets_mine.data.length}}</span>
      </h2>

      <transition name="fade">
        <div class="content"
             v-if="tickets_mine.loaded && tickets_not_assigned.error === null">
          <ticket v-for="ticket in tickets_mine.data"
                  :id="ticket._id"
                  :title="ticket.title | truncate(60)"
                  :client="ticket.client.name | truncate(60)"
                  :updated="ticket.updated_at | moment('D-M-YYYY')"
                  :key="ticket._id"></ticket>
        </div>
      </transition>

      <div class="loader" v-if="!tickets_mine.loaded"></div>
    </div>
  </div>
  </div>
</template>

<script>
import { Tickets } from '@/services/api/ApiRoutes';

export default {
  name: 'AllTickets',

  data() {
    // Set page title
    this.$parent.title.heading = 'Tickets';
    this.$parent.title.subheading = 'Hoe staan we ervoor?';

    return {
      topData: [
        {
          title: 'Open tickets',
          value: 12,
          icon: 'fa-ticket-alt',
          link: '/tickets/all',
        },
        {
          title: 'Wachtende tickets',
          value: 12,
          icon: 'fa-ticket-alt',
          link: '/tickets/all',
        },
        {
          title: 'Open tickets',
          value: 12,
          icon: 'fa-ticket-alt',
          link: '/tickets/all',
        },
        {
          title: 'Open tickets',
          value: 12,
          icon: 'fa-ticket-alt',
          link: '/tickets/all',
        },
      ],
      tableSettings: {
        headings: ['Titel', 'Klant', 'Status', 'Laatste activiteit', 'Datum aangemaakt'],
        keys: ['title', 'client', 'title', 'title', 'title'],
      },
      tickets_mine: {
        error: null,
        data: [],
        loaded: false,
      },
      tickets_not_assigned: {
        error: null,
        data: [],
        loaded: false,
      },
      per_page: 10,
      current_page: this.$route.query.page || 1,
      total_pages: 1,
    };
  },

  mounted() {
    this.getTickets();
  },

  methods: {
    getTickets() {
      Tickets.get().then((tickets) => {
        this.tickets_mine.error = null;
        this.tickets_mine.data = tickets;
        this.tickets_mine.loaded = true;
      }).catch((error) => {
        this.tickets_mine.error = error;
        this.tickets_mine.loaded = true;
      });

      Tickets.getAll({ user: false }).then((tickets) => {
        this.tickets_not_assigned.error = null;
        this.tickets_not_assigned.data = tickets;
        this.tickets_not_assigned.loaded = true;
      }).catch((error) => {
        this.tickets_not_assigned.error = error;
        this.tickets_not_assigned.loaded = true;
      });
    },

    nextPage() {
      this.current_page = parseInt(this.current_page, 10) + 1;
      this.$router.push(`/tickets/all?page=${this.current_page}`);
      this.getTickets();
    },

    prevPage() {
      this.current_page = parseInt(this.current_page, 10) - 1;
      this.$router.push(`/tickets/all?page=${this.current_page}`);
      this.getTickets();
    },
  },
};
</script>

<style scoped>
  h2 >>> span {
    font-weight: 300;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/tickets/Tickets.vue